
import { formatDateTime } from "../../../useMaintenance"
import { X } from "react-feather"

const styles = {
  banner: {
    // backgroundColor: '#e8e6e3',
    backgroundColor: "red",
    // backgroundColor: "#D61401",
    color: "#FFFFFF",
    // color: "#333333",
    padding: "16px 24px",
    fontFamily: "'JohnsonText-Regular', sans-serif",
    display: "flex",
    // alignItems: "flex-start",
    alignItems: "center",
    gap: "15px",
  },
  iconContainer: {
    // marginRight: "15px",
    // marginTop: "2px",
  },
  icon: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    // border: "2px solid #333",
    border: "2px solid #fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "bold",
  },
  content: {
    flex: 1,
  },
  title: {
    fontWeight: "bold",
    fontSize: "16px",
    marginBottom: "5px",
  },
  message: {
    margin: "0",
    fontSize: "14px",
  },
  messageSpan: {
    fontWeight: "bold",
    color: "#333",
  },
  closeButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "0",
    marginLeft: "15px",
    // color: "#333",
    color: "#fff",
  },
}

const MaintenanceBanner = ({ maintenanceData, onClose }) => {

  if (!maintenanceData) return null

  // Format the start and end times
  const startTime = formatDateTime(maintenanceData.start_time)
  const endTime = formatDateTime(maintenanceData.end_time)

  return (
    <div style={styles.banner}>

      <div style={styles.iconContainer}>
        <div style={styles.icon}>!</div>
      </div>
      
      <div style={styles.content}>
        <h2 style={styles.title}>Scheduled Maintenance</h2>
        <p style={styles.message}>
          The portal will be undergoing maintenance from {startTime} to {endTime}. During this period, access may be limited or temporarily unavailable.
        </p>
      </div>
      
      {onClose && (
        <button
          style={styles.closeButton}
          onClick={onClose}
          aria-label="Close maintenance banner"
        >
          <X size={18} />
        </button>
      )}
      
    </div>
  )
}

export default MaintenanceBanner
